var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailIconGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4762 0C13.5763 0 14.6346 0.441667 15.4131 1.23417C16.1925 2.025 16.6281 3.09167 16.6281 4.20833V10.7917C16.6281 13.1167 14.7658 15 12.4762 15H4.37177C2.08212 15 0.220703 13.1167 0.220703 10.7917V4.20833C0.220703 1.88333 2.07392 0 4.37177 0H12.4762ZM13.7808 5.44962L13.8465 5.38296C14.0425 5.14129 14.0425 4.79129 13.8374 4.54962C13.7234 4.42546 13.5667 4.34962 13.4035 4.33296C13.2312 4.32379 13.0671 4.38296 12.9432 4.49962L9.2442 7.49962C8.76838 7.90046 8.08666 7.90046 7.60346 7.49962L3.9118 4.49962C3.65667 4.30796 3.30391 4.33296 3.09143 4.55796C2.86993 4.78296 2.84532 5.14129 3.03319 5.39129L3.14065 5.49962L6.87333 8.45796C7.33274 8.82462 7.88977 9.02462 8.47305 9.02462C9.05469 9.02462 9.62157 8.82462 10.0802 8.45796L13.7808 5.44962Z",
    fill: "#8A9099"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIconGray);
export default __webpack_public_path__ + "static/media/email-icon-gray.c1c790cdace2d948d1c3c68e6efd034e.svg";
export { ForwardRef as ReactComponent };